<template>
  <div class="mapMain">
    <!-- <div class="callback" @click="JumpBack()">
      <img src="@/assets/img/btn/back.png" alt="" />
    </div> -->
    <div id="container"></div>
    <div class="mapInfoImg">
      <img src="@/assets/img/yygs/suizhou.png" alt="万林2" />
      <!-- <div class="newFind" v-if="newFindData" @click="JumpTo('/navlist/newFind')">
        <marquee class="mainFind" direction="left" scrollamount="5">
          <div class="titleFind">最新资讯：</div>
          <div class="titleFind2">{{ newFindData }}</div>
        </marquee>
      </div> -->

      <div class="m_news">
        <van-notice-bar left-icon="volume-o" :scrollable="false">
          <template #left-icon>
            <div class="news_left">最新资讯：</div>
          </template>
          <van-swipe
            vertical
            class="notice-swipe"
            :autoplay="3000"
            :show-indicators="false"
          >
            <van-swipe-item v-for="(item, index) in newsList" :key="index"
              ><a href="https://class.ctdsb.net/digimap/navlist/newFind">{{
                item.title
              }}</a></van-swipe-item
            >
          </van-swipe>
        </van-notice-bar>
      </div>
      <div class="navList">
        <van-row>
          <van-col>
            <div>
              <van-button
                round
                type="info"
                @click="JumpTo('/navlist/list', { type: '1' })"
              >
                <img src="@/assets/img/yygs/icoo_jq.png" alt="万林2" />
                <div>景区</div>
              </van-button>
            </div>
          </van-col>
          <van-col
            ><van-button
              round
              type="info"
              @click="JumpTo('/navlist/list', { type: '2' })"
            >
              <img src="@/assets/img/yygs/icoo_jd.png" alt="万林2" />
              <div>酒店</div>
            </van-button></van-col
          >
          <van-col
            ><van-button
              round
              type="info"
              @click="JumpTo('/navlist/list', { type: '4' })"
            >
              <img src="@/assets/img/yygs/icoo_ms.png" alt="万林2" />
              <div>美食</div></van-button
            ></van-col
          >
        </van-row>
      </div>
      <img
        class="btn_quanpin"
        @click="toFullOrExit()"
        src="@/assets/img/btn/zoom.png"
        alt="返回"
      />
    </div>

    <div class="pointDetails" v-show="pointDetailsShow">
      <div class="detailsMain">
        <van-row>
          <van-col span="6" class="ban_left">
            <!-- <img src="@/assets/img/sz2.png" alt="图标" /> -->
            <img :src="selectData?.image" alt="图标" />
          </van-col>
          <van-col span="13">
            <div class="oitem_cont" @click="goDetails(selectData)">
              <div class="oitem_head">
                <span> {{ selectData.address }}</span>
              </div>
              <div class="oitem_desc oitem_desc_date">
                <img src="@/assets/img/yygs/positionn.png" alt="" />
                <div>{{ selectData.photo }}</div>
              </div>
              <div class="oitem_desc">
                <img src="@/assets/img/yygs/time.png" alt="" />
                <div>{{ selectData.time }}</div>
              </div>
            </div>
          </van-col>
          <van-col span="5" class="ban_right">
            <img
              @click="baiduLocation(selectData)"
              class="detailsRight"
              src="@/assets/img/yygs/gopos.png"
              alt=""
            />
          </van-col>
        </van-row>
      </div>
    </div>
    <div class="rightBtns">
      <a href="https://vr.ctdsb.net/"><img src="@/assets/img/yygs/vr.png" alt="" /></a>
    </div>
  </div>
</template>

<script>
import { getIndexAll, getNewsLast } from "@/services/yygs";

export default {
  name: "baidu",
  components: {},
  computed: {},
  data() {
    return {
      pointDetailsShow: false,
      selectData: {},
      listPoint: [],
      newsList: [],
    };
  },
  created() {},
  mounted() {
    this.loadJScript();
    getNewsLast({ count: 3 }).then((res) => {
      if (res && res.code === 200) {
        this.newsList = res.data;
      }
    });
  },
  methods: {
    getMark(callback) {
      getIndexAll().then((res) => {
        if (res && res.code === 200) {
          this.listPoint = [];
          console.log(res.data, "首页-云游广水-地图信息列表");
          for (let key in res.data) {
            let imageIcon = "";
            let detailsType = "1";
            switch (key) {
              //活动
              case "activityVOList": {
                imageIcon = "icon_hd";
                break;
              }
              //酒店
              case "hotelVOList": {
                imageIcon = "icon_jd";
                detailsType = "2";
                break;
              }
              //城市地标
              case "attractionsCityVOList": {
                imageIcon = "icon_cs";
                break;
              }
              // 餐饮
              case "cateringVOList": {
                imageIcon = "icon_cy";
                detailsType = "4";
                break;
              }
              // 景区
              case "scenicSpotVOList": {
                imageIcon = "icon_jq";
                detailsType = "1";
                break;
              }
            }
            res.data[key].forEach((item) => {
              this.listPoint.push({
                type: detailsType,
                detailsId: item.id,
                longitude: item.longitude,
                latitude: item.latitude,
                imageIcon: require(`@/assets/img/yygs/${imageIcon}.png`),
                address: item.name || "地址为空",
                time: item.openTime || "全天",
                image: item.logo,
                photo: item.position || "全天",
              });
            });
          }
          console.log(this.listPoint, "所有的要素数据");
          if (callback) {
            callback();
          }
        }
      });
    },
    addPoint(map) {
      this.listPoint.forEach((item) => {
        var mapIcon = new BMapGL.Icon(item.imageIcon, new BMapGL.Size(35, 45), {
          anchor: new BMapGL.Size(10, 25),
        });
        // 创建标注对象并添加到地图
        // var marker = new BMapGL.Marker(point, { icon: myIcon });
        var point = new BMapGL.Point(
          Number(item.longitude) + 0.012,
          Number(item.latitude) - 0.018
        );

        point.myselfData = item;
        var marker = new BMapGL.Marker(point, {
          icon: mapIcon,
          // offset: new BMapGL.Size(40, 25),
        }); // 创建标注

        // 创建label文本标注
        const label = new BMapGL.Label(item.address, {
          offset: new BMapGL.Size(0, 0), // 文本位置移动
        });

        // 设置文本标注样式（刚开始标注隐藏，鼠标移入的时候再显示，如果要全部显示就直接控制display属性即可）
        label.setStyle({
          border: "0px",
          color: "#fff",
          fontSize: "18px",
          textShadow: "2px 2px 5px block",
          transform: "translateX(-50%)",
          backgroundColor: "000000000001", // 用于设置背景透明色
        });
        // marker.setLabel(label);
        map.addOverlay(marker); // 将标注添加到地图中
        let that = this;
        marker.addEventListener("click", function () {
          // that.pointData.show = true;
          that.pointDetailsShow = true;
          that.selectData = point.myselfData;
          // map.openInfoWindow(infoWindow, point); //开启信息窗口
        });
      });
    },
    loadJScript() {
      const that = this;
      window.init = function () {
        var map = new BMapGL.Map("container", { minZoom: 10, maxZoom: 14 }); // 创建Map实例
        // // 创建自定义的地图样式
        that.map = map;

        map.enableScrollWheelZoom(); // 启用滚轮放大缩小
        var tileLayer = new BMapGL.TileLayer();
        tileLayer.getTilesUrl = function (tileCoord, zoom) {
          if (zoom > 14) {
            return;
          }
          var x = tileCoord.x;
          var y = tileCoord.y;
          return "https://ctdsb.clouddiffuse.xyz/activity/yunyougs/tiles/" + zoom + "/tile" + x + "_" + y + ".png";
        };
        map.addTileLayer(tileLayer);
        map.centerAndZoom(new BMapGL.Point(113.835927124023, 31.6242565155029), 13);
        that.getMark(() => {
          that.addPoint(map);
        });

        setTimeout(() => {
          map._removeHybirdVectorMap();
        }, 2000);
      };
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src =
        "//api.map.baidu.com/api?type=webgl&v=1.2&ak=9DYWgdWOwOYvrYfEGzc6cPRSzkIEE6eE&callback=init";
      // script.src =
      //   "//api.map.baidu.com/api?type=webgl&v=3.0&ak=9DYWgdWOwOYvrYfEGzc6cPRSzkIEE6eE&callback=init";
      document.body.appendChild(script);
    },
    baiduLocation(data) {
      this.JumpTo("/map/mapPlan", { mapDetails: data });
    },
    goDetails(item) {
      switch (item.type) {
        case "1":
          this.JumpTo("/navlist/placeDetails", { id: item.detailsId });
          break;
        case "2":
          this.JumpTo("/navlist/details", { id: item.detailsId });
          break;
        case "4":
          this.JumpTo("/navlist/delicacy", { id: item.detailsId });
          break;
        default:
          this.JumpTo("/navlist/details", { id: item.detailsId });
      }
    },
    requestFullScreen() {
      let de = document.documentElement;
      if (de.requestFullscreen) {
        de.requestFullscreen();
      } else if (de.mozRequestFullScreen) {
        de.mozRequestFullScreen();
      } else if (de.webkitRequestFullScreen) {
        de.webkitRequestFullScreen();
      }
    },
    exitFullscreen() {
      let de = document;
      if (de.exitFullscreen) {
        de.exitFullscreen();
      } else if (de.mozCancelFullScreen) {
        de.mozCancelFullScreen();
      } else if (de.webkitCancelFullScreen) {
        de.webkitCancelFullScreen();
      }
    },
    toFullOrExit() {
      this.isFull = !this.isFull;
      if (this.isFull) {
        this.requestFullScreen();
      } else {
        this.exitFullscreen();
      }
    },
  },
};
</script>
<style>
.anchorBL {
  display: none;
}
</style>
<style lang="scss" scoped>
/*地图(容器)显示大小*/
.mapMain {
  position: absolute;
  height: 100%;
  width: 100%;
}
#container {
  height: 100%;
}
.van-col {
  margin: 0px 0.05rem;
}
.pointDetails {
  position: absolute;
  bottom: 0px;
  width: 100%;
  z-index: 10;
  border-radius: 0.3rem 0.3rem 0 0;

  background: linear-gradient(180deg, #1053d8 0%, #367bda 100%);

  .detailsMain {
    padding: 0.3rem;

    .van-row {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .ban_left {
        overflow: hidden;
        border-radius: 0.1rem;
        border: 0.01rem solid #ffffff;
        margin-right: 0.25rem;

        img {
          width: 100%;
          height: 1.1rem;
          object-fit: cover;
        }
      }

      .oitem_cont {
        color: #fff;

        .oitem_head {
          font-size: 16px;
          line-height: 16px;
          height: 16px;
          overflow: hidden;
          margin-bottom: 0.15rem;
        }

        .oitem_desc {
          margin-bottom: 0.1rem;
          div {
            font-size: 13px;
            height: 13px;
            line-height: 13px;
            overflow: hidden;
          }
        }

        .oitem_desc {
          display: flex;
          align-items: center;

          img {
            border: none;
            width: 0.25rem;
            margin-right: 0.1rem;
          }
        }
      }
    }
  }
}
.mapInfoImg {
  position: absolute;
  top: 0px;
  width: 100%;
  // height: 3rem;
  z-index: 111;
  img {
    width: 100%;
  }
}
.newFind {
  width: 100%;
  height: 0.6rem;
  z-index: 200;
  margin-top: -40px;
  position: absolute;
  .mainFind {
    height: 100%;
    width: 80%;
    background: white;
    margin: 0 auto;
    border-radius: 0.3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    .titleFind {
      display: inline-block;
      color: #046fc0;
      font-size: 14px;
    }
    .titleFind2 {
      display: inline-block;
      font-size: 14px;
    }
  }
}
.navList {
  position: absolute;
  z-index: 200;
  width: 100%;
  text-align: center;
  .van-row {
    max-width: 8rem;
    min-width: 4.6rem;
    width: 80%;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
  }
  .van-col {
    margin: 0px auto;
  }
  .van-button__text {
    display: flex;
    justify-content: center;
    // width: 1.2rem;
    align-items: center;
    img {
      width: 0.4rem;
      height: 0.32rem;
    }
  }
  .van-button--normal {
    padding: 0 0.2rem;
    font-size: 0.25rem;
    height: 0.7rem;
  }
  .van-button--info {
    background-color: rgba(0, 0, 0, 0.3);
  }
}

.btn_quanpin {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 0.8rem !important;
}
.notice-swipe {
  height: 36px;
  line-height: 36px;
}
.m_news {
  padding: 0 0.4rem 0.2rem;
  margin-top: -20px;
  .news_left {
    background-image: linear-gradient(to bottom, #0748c7, #6595f4);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-weight: bolder;
  }
}
.rightBtns {
    position: fixed;
    right: 0.2rem;
    top: 50%;
    transform: translateY(-50%);
    width: 1.5rem;
    z-index:9999;
    img {
      width: 100%;
    }
  }
</style>
